export function compactQty(value: unknown): string {
  const n = typeof value === 'number' ? value : parseFloat(String(value ?? '').replace(/,/g, ''))
  if (!Number.isFinite(n)) return String(value ?? '').trim()
  const rounded = Number(n.toFixed(4))
  return String(rounded)
}

export function parseStockLine(message: string): { qty?: string; min?: string } {
  const ar = message.match(/الكمية\s*:?\s*([\d.,]+)\s*\/\s*الحد\s*الأدنى\s*:?\s*([\d.,]+)/i)
  if (ar) return { qty: compactQty(ar[1]), min: compactQty(ar[2]) }
  const en = message.match(/qty(?:uantity)?\s*:?\s*([\d.,]+)\s*\/\s*(?:min(?:imum)?|حد)\s*:?\s*([\d.,]+)/i)
  if (en) return { qty: compactQty(en[1]), min: compactQty(en[2]) }
  return {}
}

export function compactRelativeTime(iso: string | undefined, isRTL: boolean): string {
  if (!iso) return ''
  const then = new Date(iso).getTime()
  if (!Number.isFinite(then)) return ''
  const mins = Math.max(0, Math.round((Date.now() - then) / 60000))
  if (mins < 1) return isRTL ? 'الآن' : 'Just now'
  if (mins === 1) return isRTL ? 'منذ دقيقة' : '1 min ago'
  if (mins < 60) return isRTL ? `منذ ${mins} دقائق` : `${mins} min ago`
  const hours = Math.round(mins / 60)
  if (hours === 1) return isRTL ? 'منذ ساعة' : '1 hr ago'
  if (hours < 24) return isRTL ? `منذ ${hours} ساعات` : `${hours} hr ago`
  const days = Math.round(hours / 24)
  return isRTL ? `منذ ${days} يوم` : `${days}d ago`
}

export function sourceLabel(source: string, type: string, isRTL: boolean): string {
  if (source === 'fuel') return isRTL ? 'نظام المحطات' : 'Fuel station'
  if (source === 'inbox') return isRTL ? 'منشئ الإشعارات' : 'Notification engine'
  if (source === 'local') return isRTL ? 'النظام' : 'System'
  const t = (type || '').toLowerCase()
  if (t === 'lowstock') return isRTL ? 'نظام المخزون' : 'Inventory'
  if (t === 'itemexpiry') return isRTL ? 'صلاحية الأصناف' : 'Item expiry'
  if (t.includes('invoice') || t.includes('installment')) return isRTL ? 'المبيعات / المشتريات' : 'Invoices'
  return isRTL ? 'النظام' : 'System'
}
